import { createSlice } from "@reduxjs/toolkit";

export const EventMetaSlice = createSlice({
  name: "eventMetaSlice",
  initialState: {
    eventDomainOptions: [],
    eventRegionOptions: [],
    eventUsageOptions: [],
    eventCategoryOptions: [],
    eventSubCategoryOptions: {}
  },
  reducers: {
    setEventDomainOptions(state, action) {
      state.eventDomainOptions = action.payload.map(
        (item: string, i: number) => {
          return {
            id: i,
            name: item,
            value: item
          };
        }
      );
    },

    setEventRegionOptions(state, action) {
      state.eventRegionOptions = action.payload.map(
        (item: string, i: number) => {
          return {
            id: i,
            name: item,
            value: item
          };
        }
      );
    },
    setEventUsageOptions(state, action) {
      state.eventUsageOptions = action.payload.map(
        (item: string, i: number) => {
          return {
            id: i,
            name: item,
            value: item
          };
        }
      );
    },
    setEventCategoryOptions(state, action) {
      state.eventCategoryOptions = action.payload.map(
        (item: string, i: number) => {
          return {
            id: i,
            name: item,
            value: item
          };
        }
      );
    },
    setEventSubCategoryOptions(state, action) {
      state.eventSubCategoryOptions = action.payload;
    }
  }
});

export default EventMetaSlice;

export const {
  setEventDomainOptions,
  setEventRegionOptions,
  setEventUsageOptions,
  setEventCategoryOptions,
  setEventSubCategoryOptions
} = EventMetaSlice.actions;
